import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue";
import _imports_0 from './../assets/images/logo.png';
const _hoisted_1 = {
  class: "header_page"
};
const _hoisted_2 = {
  id: "header",
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "van-icon van-icon-bars",
  style: {
    "font-size": "1.8rem"
  }
}, null, -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "data-src": "img/h_game.1e084e3f.png",
  alt: "",
  srcset: "",
  style: {
    "width": "2rem",
    "height": "2rem",
    "margin": "0px 0.5rem 0px 0.8rem"
  }
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Happy Games", -1);
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  t: "1680076681234",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2764",
  width: "1.5rem",
  height: "1.5rem",
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M955.733333 923.733333l-149.333333-153.6C876.8 693.333333 917.333333 593.066667 917.333333 490.666667c0-224-181.333333-405.333333-405.333333-405.333334S106.666667 266.666667 106.666667 490.666667s181.333333 405.333333 405.333333 405.333333c64 0 125.866667-14.933333 183.466667-42.666667 10.666667-4.266667 14.933333-17.066667 8.533333-27.733333-4.266667-10.666667-19.2-14.933333-27.733333-8.533333-51.2 25.6-106.666667 38.4-164.266667 38.4-200.533333 0-362.666667-162.133333-362.666667-362.666667S311.466667 128 512 128s362.666667 162.133333 362.666667 362.666667c0 100.266667-42.666667 196.266667-115.2 264.533333-8.533333 8.533333-8.533333 21.333333 0 29.866667 2.133333 2.133333 4.266667 4.266667 8.533333 4.266666l157.866667 162.133334c4.266667 4.266667 10.666667 6.4 14.933333 6.4 6.4 0 10.666667-2.133333 14.933333-6.4 6.4-6.4 8.533333-19.2 0-27.733334z",
  fill: "#ffffff",
  "p-id": "2765"
})], -1);
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  key: 0,
  class: "search_box search_box"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  t: "1680079992751",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "15827",
  width: "2rem",
  height: "2rem",
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M606.72 668.949333l62.144-62.144 248.298667 248.298667-62.144 62.144z",
  fill: "#607D8B",
  "p-id": "15828"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M426.666667 426.666667m-320 0a320 320 0 1 0 640 0 320 320 0 1 0-640 0Z",
  fill: "#607D8B",
  "p-id": "15829"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M426.666667 426.666667m-256 0a256 256 0 1 0 512 0 256 256 0 1 0-512 0Z",
  fill: "#B3E5FC",
  "p-id": "15830"
})], -1);
const _hoisted_12 = [_hoisted_11];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PopupBar = _resolveComponent("PopupBar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "menu",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleClickMenu && $setup.handleClickMenu(...args))
  }, _hoisted_4), _createElementVNode("div", {
    style: {
      "display": "flex",
      "justify-content": "left",
      "align-items": "center",
      "flex": "1 1 0%"
    },
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.goHome && $setup.goHome(...args))
  }, _hoisted_7), _createElementVNode("div", {
    class: "search",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.handleClick && $setup.handleClick(...args))
  }, _hoisted_9)]), $setup.showSerachInput ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
    onKeyup: _cache[3] || (_cache[3] = _withKeys((...args) => $setup.handleSerach && $setup.handleSerach(...args), ["enter"])),
    type: "text",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.inputValue = $event),
    placeholder: "search your games",
    clearable: "",
    defaultvalue: ""
  }, null, 544), [[_vModelText, $setup.inputValue]]), _createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.handleSerach && $setup.handleSerach(...args))
  }, _hoisted_12)])) : _createCommentVNode("", true)])]), _createVNode(_component_PopupBar, {
    show: $setup.showPop
  }, null, 8, ["show"])], 64);
}